import { render, staticRenderFns } from "./Instagramfeed.vue?vue&type=template&id=670549ef&scoped=true"
import script from "./Instagramfeed.vue?vue&type=script&lang=js"
export * from "./Instagramfeed.vue?vue&type=script&lang=js"
import style0 from "./Instagramfeed.vue?vue&type=style&index=0&id=670549ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670549ef",
  null
  
)

export default component.exports